<template>
  <div class="stamp-menu">
    <MenuHeader title="水印" />
    <LabelSwitch
      label="启用水印"
      :bold="true"
      :value="stampEnabled"
      @change="toggleEnabled"
      :large='true'
    />
    <div
      class="stamp-selector"
      @click="selectStampType('imageStamp')"
      :class="[
        'stamp-selector',
        { 'stamp-selector-active': stampType === 'imageStamp' }
      ]"
    >
      <a-checkbox
        @change="onChange"
        class="check-box"
        :checked="stampType === 'imageStamp'"
      >
        <span class="label">图片水印</span>
      </a-checkbox>
      <div class="image-file-name">
        <template v-if="stamp.url">
          <img :src="stamp.url" alt="" class="image" />
          <div class="file-name">
            {{stamp.url.replace(/^.+\/([^/]+)$/, '$1')}}
          </div>
        </template>
        <template v-else>
          尚未设置图片水印。
        </template>
      </div>
    </div>

    <!-- <div
               :class="['stamp-selector',{'stamp-selector-active':stampType === 'textStamp'}]"
               @click='selectStampType("textStamp")'
       >
           <a-checkbox @change="onChange" class='check-box' :checked="stampType === 'textStamp'">
               <span class='label'>文字水印</span>
           </a-checkbox>
           <div class='text-stamp-content'>
               水印文字内容
           </div>
       </div> -->

    <div class="tips">
      <span class="icon iconfont">&#xe62f;</span>
      提示：
    </div>
    <div class="tips-content">
      水印设置后将应用于整个视频的各个片段中。
    </div>
  </div>
</template>

<script>
  import MenuHeader from "../base/MenuHeader";
  import LabelSwitch from "../base/LabelSwitch";
  import { mapActions, mapState } from 'vuex';

  export default {
  name: "StampMenu",
  components: { MenuHeader, LabelSwitch },
  computed: {
    ...mapState(['stampEnabled', 'stampType', 'stamp'])
  },
  methods: {
    ...mapActions(['selectStampType']),
    onChange: function (event) {
      console.log(event)
    },
    toggleEnabled(value) {
      this.$store.commit('handleStampEnabled', value);
    }
  }
}
</script>

<style scoped>
.stamp-menu {
  background: rgba(247, 248, 249, 1);
  box-shadow: -1px 0 0 0 rgba(220, 220, 222, 1);
  padding: 10px 20px;
  height: 100%;
  overflow-y: auto;
}

.stamp-selector {
  height: 92px;
  background: rgba(236, 240, 241, 1);
  border: 1px solid transparent;
  margin-top: 29px;
  cursor: pointer;
}

.stamp-selector-active {
  border: 1px solid rgba(0, 126, 255, 1);
}

.check-box {
  width: 214px;
  border-bottom: 1px solid rgba(216, 216, 216, 1);
  margin: 7px auto 0 auto;
  padding-bottom: 4px;
  display: block;
}

.label {
  font-size: 12px;
  font-weight: 500;
}

.image-file-name {
  display: flex;
  align-items: center;
  height: 58px;
  padding: 0 12px;
}

.file-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.image {
  width: 43px;
  height: 43px;
  object-fit: cover;
  margin-right: 11px;
}

.text-stamp-content {
  font-size: 16px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.65);
  line-height: 62px;
  text-align: center;
}

.icon {
  color: #e4b634;
  display: inline-block;
  margin-right: 6px;
  font-size: 12px;
}

.tips {
  font-size: 12px;
  font-weight: 400;
  color: rgba(18, 32, 55, 1);
  margin-top: 24px;
}

.tips-content {
  font-size: 12px;
  font-weight: 400;
  margin-top: 5px;
}
</style>
